import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  conteudo: {
    padding: 16,
    paddingBottom: 48,
  },
  spinner: {
    marginTop: 40,
  },
  subtituloTela: {
    fontSize: 14,
    color: Colors.GrayPallete.grayTwo,
    marginTop: 4,
  },
  avisoSomenteLeitura: {
    backgroundColor: Colors.GrayPallete.lightgray,
    borderRadius: 8,
    padding: 12,
    marginTop: 16,
  },
  avisoSomenteLeituraTexto: {
    fontSize: 13,
    color: Colors.GrayPallete.grayOne,
  },
  avisoAjuste: {
    backgroundColor: Colors.adviceBackground,
    borderRadius: 8,
    padding: 12,
    marginTop: 12,
  },
  avisoAjusteTitulo: {
    fontSize: 14,
    fontWeight: '700',
    color: Colors.GrayPallete.grayOne,
  },
  avisoAjusteTexto: {
    fontSize: 13,
    color: Colors.GrayPallete.grayOne,
    marginTop: 4,
  },
  linha: {
    borderBottomWidth: 1,
    borderBottomColor: Colors.GrayPallete.lightgrayTwo,
    paddingVertical: 12,
  },
  linhaRemovida: {
    opacity: 0.7,
  },
  linhaTitulo: {
    fontSize: 14,
    fontWeight: '600',
    color: Colors.GrayPallete.grayOne,
  },
  linhaValores: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 6,
  },
  linhaTexto: {
    fontSize: 13,
    color: Colors.GrayPallete.grayTwo,
    flexShrink: 1,
  },
  linhaDestaque: {
    fontWeight: '700',
    color: Colors.GrayPallete.grayOne,
  },
  linhaSubtotal: {
    fontSize: 14,
    fontWeight: '700',
    color: Colors.GrayPallete.grayOne,
    marginLeft: 8,
  },
  linhaAviso: {
    fontSize: 12,
    color: Colors.OrangePallete.orange,
    marginTop: 6,
  },
  linhaAvisoPreco: {
    fontSize: 12,
    color: Colors.RedPallete.red,
    marginTop: 4,
  },
  linhaRemovidaTexto: {
    fontSize: 12,
    color: Colors.RedPallete.red,
    marginTop: 6,
  },
  textoRiscado: {
    textDecorationLine: 'line-through',
    color: Colors.GrayPallete.grayTwo,
  },
  blocoEntrega: {
    marginTop: 12,
    borderRadius: 8,
    padding: 10,
    backgroundColor: Colors.GrayPallete.lightgray,
  },
  blocoEntregaDivergente: {
    backgroundColor: '#FFF4E5',
    borderWidth: 1,
    borderColor: '#F0A202',
  },
  blocoEntregaTexto: {
    fontSize: 13,
    color: Colors.GrayPallete.grayOne,
  },
  blocoEntregaTextoDivergente: {
    fontWeight: '700',
    color: '#8A5A00',
  },
  blocoVenda: {
    marginTop: 16,
    borderWidth: 1,
    borderColor: Colors.GrayPallete.lightgrayTwo,
    borderRadius: 8,
    padding: 12,
  },
  blocoVendaInativo: {
    opacity: 0.6,
  },
  blocoVendaCabecalho: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  blocoVendaTitulo: {
    fontSize: 14,
    fontWeight: '700',
    color: Colors.GrayPallete.grayOne,
  },
  blocoVendaSelo: {
    fontSize: 11,
    fontWeight: '700',
    color: Colors.GrayPallete.grayTwo,
  },
  blocoVendaSeloAlerta: {
    fontSize: 11,
    fontWeight: '700',
    color: Colors.RedPallete.red,
  },
  blocoVendaTextoAlerta: {
    fontSize: 13,
    color: Colors.GrayPallete.grayTwo,
    lineHeight: 18,
  },
  blocoVendaTotal: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: Colors.GrayPallete.lightgrayTwo,
  },
  blocoVendaTotalRotulo: {
    fontSize: 13,
    color: Colors.GrayPallete.grayTwo,
  },
  blocoVendaTotalValor: {
    fontSize: 13,
    fontWeight: '700',
    color: Colors.GrayPallete.grayOne,
  },
  blocoBonificacao: {
    marginTop: 16,
    borderRadius: 8,
    padding: 12,
    backgroundColor: Colors.GrayPallete.lightgray,
  },
  blocoBonificacaoTitulo: {
    fontSize: 14,
    fontWeight: '700',
    color: Colors.GrayPallete.grayOne,
  },
  blocoBonificacaoTexto: {
    fontSize: 12,
    color: Colors.GrayPallete.grayTwo,
    marginTop: 4,
    lineHeight: 16,
  },
  blocoBonificacaoLinha: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 8,
  },
  blocoBonificacaoLinhaTexto: {
    flex: 1,
    fontSize: 13,
    color: Colors.GrayPallete.grayOne,
    paddingRight: 8,
  },
  blocoBonificacaoLinhaQtd: {
    fontSize: 13,
    fontWeight: '700',
    color: Colors.GrayPallete.grayOne,
  },
  totalObservacao: {
    fontSize: 12,
    color: Colors.GrayPallete.grayTwo,
    marginTop: 6,
  },
  avisoPagamentos: {
    fontSize: 12,
    color: Colors.GrayPallete.grayTwo,
    marginTop: 16,
    marginBottom: -8,
    textAlign: 'center',
  },
  blocoIndisponiveis: {
    marginTop: 16,
    borderRadius: 8,
    padding: 12,
    backgroundColor: Colors.GrayPallete.lightgray,
  },
  blocoIndisponiveisTitulo: {
    fontSize: 13,
    fontWeight: '700',
    color: Colors.GrayPallete.grayOne,
  },
  blocoIndisponiveisTexto: {
    fontSize: 12,
    color: Colors.GrayPallete.grayTwo,
    marginTop: 4,
  },
  totais: {
    marginTop: 20,
    borderTopWidth: 1,
    borderTopColor: Colors.GrayPallete.lightgrayTwo,
    paddingTop: 12,
  },
  totalLinha: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 6,
  },
  totalRotulo: {
    fontSize: 13,
    color: Colors.GrayPallete.grayTwo,
  },
  totalValor: {
    fontSize: 13,
    color: Colors.GrayPallete.grayTwo,
  },
  totalRotuloForte: {
    fontSize: 15,
    fontWeight: '700',
    color: Colors.GrayPallete.grayOne,
  },
  totalValorForte: {
    fontSize: 17,
    fontWeight: '700',
    color: Colors.GrayPallete.grayOne,
  },
  blocoInviavel: {
    marginTop: 20,
    borderRadius: 8,
    padding: 12,
    borderWidth: 1,
    borderColor: Colors.RedPallete.red,
  },
  blocoInviavelTitulo: {
    fontSize: 14,
    fontWeight: '700',
    color: Colors.RedPallete.red,
  },
  blocoInviavelTexto: {
    fontSize: 13,
    color: Colors.GrayPallete.grayOne,
    marginTop: 4,
  },
  blocoConsulta: {
    marginTop: 20,
    borderRadius: 8,
    padding: 12,
    backgroundColor: Colors.adviceBackground,
  },
  blocoConsultaTexto: {
    fontSize: 14,
    fontWeight: '600',
    color: Colors.GrayPallete.grayOne,
    textAlign: 'center',
  },
  botaoPrimario: {
    marginTop: 20,
    backgroundColor: Colors.RedPallete.red,
    borderRadius: 8,
    paddingVertical: 14,
    alignItems: 'center',
  },
  botaoPrimarioTexto: {
    color: '#FFFFFF',
    fontSize: 15,
    fontWeight: '700',
  },
  botaoSecundario: {
    marginTop: 12,
    paddingVertical: 12,
    alignItems: 'center',
  },
  botaoSecundarioTexto: {
    color: Colors.GrayPallete.grayTwo,
    fontSize: 14,
    fontWeight: '600',
  },
  estadoVazio: {
    marginTop: 40,
    alignItems: 'center',
    paddingHorizontal: 16,
  },
  estadoVazioTitulo: {
    fontSize: 15,
    fontWeight: '600',
    color: Colors.GrayPallete.grayOne,
    textAlign: 'center',
  },
  tentarNovamente: {
    fontSize: 14,
    fontWeight: '700',
    color: Colors.RedPallete.red,
    marginTop: 12,
  },
  voltar: {
    fontSize: 14,
    fontWeight: '600',
    color: Colors.GrayPallete.grayTwo,
    marginTop: 12,
  },
});
